import React, { useEffect, useMemo, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { FORM_FIELDS_NAME } from "./constant";
import { getFormBaseValidationRule } from "../../../utils/form/form-utils";
import { classNames } from "primereact/utils";
import { Button } from "primereact/button";
import { Col, Container, Row } from "react-bootstrap";
import { Panel } from "primereact/panel";
import {
  plasticType,
  cardManagementProperties,
  cardStatusType,
  driverVehivleIdentifier,
  cardProperties,
  cardmonetaryProperties,
  WeeklyFuelPurchaseProperties,
  fuelPurchaseLimitationProperties,
  nonHighwayFuelPurchaseProperties,
  weeksDay,
} from "./data.json";
import EzControlledDropDowntWithFloatingLabel from "../../../common/EzForm/EzControlledDropDown/WithFloatingLabel";
import { Divider } from "primereact/divider";
import "./styles.css";
import { loadingsShow } from "../../../Services/PostAPI";
import EzControlledCheckBoxWithLabel from "../../../common/EzForm/EzControlledCheckBox/WithLabel";
import EzControlledInput from "../../../common/EzForm/EzControlledInput";
import { goBack } from "../../../utils/gotoback";

const CreateManageCardComponent = (props) => {
  const {
    isEdit,
    isView,
    isLoading,
    navigateToCardManageSummaryScreen,
    createManageCard,
    editManageCard,
    formFieldValueMap,
    isManageCardDetailSuccess,
    isCreateManageCardSuccess,
    isEditManageCardSuccess,
    isEditManageCardError,
    shouldBlockNavigation,
  } = props;

  useEffect(() => {
    setTimeout(() => loadingsShow("none"), 1000);
  }, []);

  const {
    control,
    formState: { errors, isDirty },
    watch,
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: useMemo(() => {
      console.log("check value come or not", formFieldValueMap);
      return formFieldValueMap;
    }, [formFieldValueMap]),
  });
  const ref = useRef(null);

  useEffect(() => {
    if (isCreateManageCardSuccess || isEditManageCardSuccess) {
      reset();
      navigateToCardManageSummaryScreen();
    }
  }, [isCreateManageCardSuccess]);

  useEffect(() => {
    if (isManageCardDetailSuccess) {
      reset({
        ...formFieldValueMap,
      });
    }
  }, [isManageCardDetailSuccess]);

  useEffect(() => {
    if (isCreateManageCardSuccess || isEditManageCardSuccess) {
      shouldBlockNavigation(false);
    } else shouldBlockNavigation(isDirty);
  }, [isDirty, isCreateManageCardSuccess, isEditManageCardSuccess]);

  const onSubmit = (data) => {
    const {
      cash_refresh_days,
      non_highway_fuel_weekly_refresh_day,
      weekly_vehicle_quantity_refresh_day,
      ...rest
    } = data;

    const stringifiedData = {
      ...rest,
      cash_refresh_days: JSON.stringify(cash_refresh_days),
      non_highway_fuel_weekly_refresh_day: JSON.stringify(
        non_highway_fuel_weekly_refresh_day
      ),
      weekly_vehicle_quantity_refresh_day: JSON.stringify(
        weekly_vehicle_quantity_refresh_day
      ),
    };
    isEdit
      ? editManageCard({ id: data.id, data: stringifiedData })
      : createManageCard(stringifiedData);
  };

  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  const renderPageHeaderSection = () => {
    return (
      <div className="make-relative sub-header ">
        <Button
          tooltip={"Back to Manage Cards summary"}
          tooltipOptions={{ position: "left" }}
          label={"List of ManageCard"}
          // icon={"pi pi-arrow-left"}
          className={`p-button p-button-raised`}
          onClick={navigateToCardManageSummaryScreen}
        />
      </div>
    );
  };
  const panelHeaderLeftToggle = (options, showLastUpdated = false) => (
    <div
      className={`${options.className} `}
      style={{
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <div>
        {options.togglerElement}
        <span className="p-panel-title ml-2">{options.titleElement}</span>
        {options.icons}
      </div>
      {showLastUpdated && (
        <div>
          <b className="mr-2">
            <span>Last Updated at</span> {new Date().toLocaleString()}{" "}
          </b>
        </div>
      )}
    </div>
  );

  return (
    <div className="paddingbox">
      <div
        className={classNames("containerboxform", { "p-disabled": isLoading })}
      >
        {renderPageHeaderSection()}
        <div className="form-demo">
          <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
            <Panel
              ref={ref}
              header="Card Management"
              className="mt-2"
              toggleable
              headerTemplate={(options) => panelHeaderLeftToggle(options, true)}
              expandIcon="pi pi-angle-right"
              collapseIcon="pi pi-angle-down"
            >
              <Row className="gap-3 g-5">
                {cardManagementProperties?.map((item) => (
                  <Col md={3} key={item?.label}>
                    {item.type === "dropdown" ? (
                      isEdit ? (
                        <EzControlledDropDowntWithFloatingLabel
                          name={item?.name}
                          control={control}
                          rules={
                            getFormBaseValidationRule().DEFAULT.VALIDATION_RULE
                          }
                          optionLabel={"name"}
                          optionValue={"id"}
                          options={item?.name === FORM_FIELDS_NAME.PLASTIC_TYPE ? plasticType : cardStatusType}
                          isError={errors[item?.name]}
                          errorMsg={getFormErrorMessage(item?.name)}
                          label={item?.label}
                          labelClassName={"ml-2"}
                          disabled={isView || !isEdit}
                          inputClassName={
                            isView || !isEdit ? "custom-disabled-input" : ""
                          }
                        />
                      ) : (
                        <EzControlledInput
                          name={item?.name}
                          control={control}
                          label={item?.label}
                          type={"text"}
                          rules={item?.rule}
                          isError={errors[item?.name]}
                          errorMsg={getFormErrorMessage(item?.name)}
                          disabled={isView || !isEdit}
                          inputClassName={
                            isView || !isEdit ? "custom-disabled-input" : ""
                          }
                        />
                      )
                    ) : (
                      <EzControlledInput
                        name={item?.name}
                        control={control}
                        label={item?.label}
                        type={item?.type}
                        rules={item?.rule}
                        isError={errors[item?.name]}
                        errorMsg={getFormErrorMessage(item?.name)}
                        disabled={isView || !isEdit}
                        inputClassName={
                          isView || !isEdit ? "custom-disabled-input" : ""
                        }
                      />
                    )}
                  </Col>
                ))}
              </Row>
            </Panel>
            <Panel
              ref={ref}
              header="Driver/Vehicle Identifiers"
              className="mt-2"
              toggleable
              headerTemplate={panelHeaderLeftToggle}
              expandIcon="pi pi-angle-right"
              collapseIcon="pi pi-angle-down"
            >
              <Row>
                {driverVehivleIdentifier?.map((item) => (
                  <Col md={3} key={item?.label}>
                    <EzControlledInput
                      name={item?.name}
                      control={control}
                      label={item?.label}
                      rules={item?.rule}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      disabled={isView || !isEdit}
                      inputClassName={
                        isView || !isEdit ? "custom-disabled-input" : ""
                      }
                    />
                  </Col>
                ))}
              </Row>
            </Panel>
            <Panel
              ref={ref}
              header="Card Properties"
              className="mt-2"
              toggleable
              collapsed={true}
              headerTemplate={panelHeaderLeftToggle}
              expandIcon="pi pi-angle-right"
              collapseIcon="pi pi-angle-down"
            >
              <Row>
                {cardProperties?.map((item) => (
                  <Col md={3} key={item?.label}>
                    <EzControlledInput
                      name={item?.name}
                      control={control}
                      label={item?.label}
                      type={item?.type}
                      rules={item?.rule}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      disabled={isView || !isEdit}
                      inputClassName={
                        isView || !isEdit ? "custom-disabled-input" : ""
                      }
                    />
                  </Col>
                ))}
              </Row>
            </Panel>

            <Panel
              ref={ref}
              header="Card Monetary Properties"
              className="mt-2"
              toggleable
              collapsed={true}
              headerTemplate={panelHeaderLeftToggle}
              expandIcon="pi pi-angle-right"
              collapseIcon="pi pi-angle-down"
            >
              <Row>
                {cardmonetaryProperties?.map((item) => (
                  <React.Fragment key={item?.label}>
                    {item.name !== FORM_FIELDS_NAME.CASH_REFRESH_DAYS ? (
                      <Col md={3}>
                        <EzControlledInput
                          name={item?.name}
                          control={control}
                          type={item?.type}
                          label={item?.label}
                          rules={item?.rule}
                          isError={errors[item?.name]}
                          errorMsg={getFormErrorMessage(item?.name)}
                          disabled={isView || !isEdit}
                          inputClassName={
                            isView || !isEdit ? "custom-disabled-input" : ""
                          }
                        />
                      </Col>
                    ) : (
                      <Col md={6}>
                        <Row>
                          <Col md={12}>
                            <p> {item.label} </p>
                          </Col>
                          {weeksDay?.map((weekItem) => (
                            <Col
                              xs={6}
                              lg={3}
                              key={`${item.label}_${weekItem.label}`}
                            >
                              <EzControlledCheckBoxWithLabel
                                name={`${item.name}.${weekItem.name}`}
                                control={control}
                                label={weekItem?.label}
                                rules={weekItem?.rule}
                                labelClassName={"ml-2"}
                                defaultChecked={false}
                                isError={
                                  errors[`${item.name}.${weekItem.name}`]
                                }
                                errorMsg={getFormErrorMessage(
                                  `${item.name}.${weekItem.name}`
                                )}
                                disabled={isView || !isEdit}
                              />
                            </Col>
                          ))}
                        </Row>
                      </Col>
                    )}
                  </React.Fragment>
                ))}
              </Row>
            </Panel>

            <Panel
              ref={ref}
              header="Weekly Fuel Purchase Properties"
              className="mt-2"
              toggleable
              collapsed={true}
              headerTemplate={panelHeaderLeftToggle}
              expandIcon="pi pi-angle-right"
              collapseIcon="pi pi-angle-down"
            >
              <Row>
                {WeeklyFuelPurchaseProperties?.map((item) => (
                  <React.Fragment key={item?.label}>
                    {item.name !==
                    FORM_FIELDS_NAME.WEEKLY_VEHICLE_QUANTITY_REFRESH_DAY ? (
                      <Col md={3}>
                        <EzControlledInput
                          name={item?.name}
                          control={control}
                          label={item?.label}
                          type={item?.type}
                          rules={item?.rule}
                          isError={errors[item?.name]}
                          errorMsg={getFormErrorMessage(item?.name)}
                          disabled={isView || !isEdit}
                          inputClassName={
                            isView || !isEdit ? "custom-disabled-input" : ""
                          }
                        />
                      </Col>
                    ) : (
                      <Col md={6}>
                        <Row>
                          <Col md={12}>
                            <p> {item.label} </p>
                          </Col>
                          {weeksDay?.map((weekItem) => (
                            <Col
                              xs={6}
                              lg={3}
                              key={`${item.label}_${weekItem.label}`}
                            >
                              <EzControlledCheckBoxWithLabel
                                name={`${item.name}.${weekItem.name}`}
                                control={control}
                                label={weekItem?.label}
                                rules={weekItem?.rule}
                                labelClassName={"ml-2"}
                                defaultChecked={false}
                                isError={
                                  errors[`${item.name}.${weekItem.name}`]
                                }
                                errorMsg={getFormErrorMessage(
                                  `${item.name}.${weekItem.name}`
                                )}
                                disabled={isView || !isEdit}
                              />
                            </Col>
                          ))}
                        </Row>
                      </Col>
                    )}
                  </React.Fragment>
                ))}
              </Row>
            </Panel>
            <Panel
              ref={ref}
              header="Fuel Purchase Limitation Properties"
              className="mt-2"
              toggleable
              collapsed={true}
              headerTemplate={panelHeaderLeftToggle}
              expandIcon="pi pi-angle-right"
              collapseIcon="pi pi-angle-down"
            >
              <Row>
                {fuelPurchaseLimitationProperties?.map((item) => (
                  <Col md={3} key={item?.label}>
                    <EzControlledInput
                      name={item?.name}
                      control={control}
                      label={item?.label}
                      type={item?.type}
                      rules={item?.rule}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      disabled={isView || !isEdit}
                      inputClassName={
                        isView || !isEdit ? "custom-disabled-input" : ""
                      }
                    />
                  </Col>
                ))}
              </Row>
            </Panel>
            <Panel
              ref={ref}
              header="Non-Highway Fuel Purchase Properties"
              className="mt-2"
              toggleable
              collapsed={true}
              headerTemplate={panelHeaderLeftToggle}
              expandIcon="pi pi-angle-right"
              collapseIcon="pi pi-angle-down"
            >
              <Row>
                {nonHighwayFuelPurchaseProperties?.map((item) => (
                  <Col md={3} key={item?.label}>
                    {item.name !==
                    FORM_FIELDS_NAME.NON_HIGHWAY_FUEL_WEEKLY_REFRESH_DAY ? (
                      <EzControlledInput
                        name={item?.name}
                        control={control}
                        type={item?.type}
                        label={item?.label}
                        rules={item?.rule}
                        isError={errors[item?.name]}
                        errorMsg={getFormErrorMessage(item?.name)}
                        disabled={isView || !isEdit}
                        inputClassName={
                          isView || !isEdit ? "custom-disabled-input" : ""
                        }
                      />
                    ) : (
                      <Row>
                        <Col md={12}>
                          <p> {item.label} </p>
                        </Col>
                        {weeksDay?.map((weekItem) => (
                          <Col
                            xs={6}
                            lg={3}
                            key={`${item.label}_${weekItem.label}`}
                          >
                            <EzControlledCheckBoxWithLabel
                              name={`${item.name}.${weekItem.name}`}
                              control={control}
                              label={weekItem?.label}
                              rules={weekItem?.rule}
                              labelClassName={"ml-2"}
                              defaultChecked={false}
                              isError={errors[`${item.name}.${weekItem.name}`]}
                              errorMsg={getFormErrorMessage(
                                `${item.name}.${weekItem.name}`
                              )}
                              disabled={isView || !isEdit}
                            />
                          </Col>
                        ))}
                      </Row>
                    )}
                  </Col>
                ))}
              </Row>
            </Panel>
            <div
              className="make-flex mt-2 mr-2"
              style={{
                width: "100%",
                justifyContent: "flex-end",
                display: "flex",
              }}
            >
              {isEdit ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    width: "100%",
                  }}
                >
                  <div style={{ margin: "15px 10px", minWidth: "100px" }}>
                    <Button
                      label="Cancel"
                      type="button"
                      className="p-btn-danger p-button-outlined mt-2"
                      onClick={goBack}
                    />
                  </div>
                  <div style={{ margin: "15px 10px", minWidth: "100px" }}>
                    <Button
                      type="submit"
                      label={isEdit ? "Update" : "Save"}
                      className="mt-2 p-button-raised"
                    />
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateManageCardComponent;
